import { UserCreationFormTemplate } from '../UserCreationFormTemplate';

export class TenantAdminUserCreatorTemplate extends UserCreationFormTemplate {
  public availableUserTypes = undefined;

  public static create = (): UserCreationFormTemplate => {
    return new TenantAdminUserCreatorTemplate();
  };
}
